module.exports = __webpack_public_path__ + "static/media/refresh-icon.76490809.svg";